import { CopyButton } from "@/components/ui/copy-button";
import { useActiveFileName } from "@/lib/hooks/useActiveFileName";
import { useActiveVersionNumber } from "@/lib/hooks/useActiveVersionNumber";
import { useMessageStore } from "@/state/stores";
import { useShallow } from "zustand/shallow";
import { SourceCode } from "../SourceCode";

export function FileOutput() {
  const versionNumber = useActiveVersionNumber();
  const fileName = useActiveFileName();
  const currentFile = useMessageStore(
    useShallow((state) => {
      const versionInfo = Object.values(state.versionInformation).find(
        (info) => info.version === versionNumber,
      );

      if (!versionInfo) {
        return undefined;
      }

      return versionInfo.files.find((file) => file.filename === fileName);
    }),
  );

  const isFileProcessing = currentFile?.status === "processing";

  return (
    <div className="grid grid-rows-[auto_1fr] h-full">
      <div className="flex items-center justify-between px-4 border-b h-10">
        <span className="font-mono text-sm">
          {currentFile?.path || currentFile?.filename}
        </span>
        <CopyButton value={currentFile?.content || ""} />
      </div>

      {currentFile ? (
        <SourceCode
          key={`${versionNumber}-${currentFile.filename}`}
          content={currentFile.content}
          className="p-3 min-h-full"
          isStreaming={isFileProcessing}
          language={currentFile.filename.endsWith(".json") ? "json" : "ts"}
          enableOverflow
        />
      ) : (
        <div className="flex items-center justify-center h-full">
          <div>{fileName ? "File not found" : "No file selected"}</div>
        </div>
      )}
    </div>
  );
}
